import React from 'react';
import { Label } from 'semantic-ui-react';

export default <Label color="red" pointing />;
